// @flow
import React from 'react';
import { ProductSpaceIntroduction } from 'Components/widgets/product-space-introduction/ProductSpaceIntroduction.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';
import { addTranslationKeys } from 'Src/i18n';

type Props = {|
  config: CMSContent,
  id: string,
  imageSrc?: string,
  text?: string,
  title?: string,
  link?: {
    url: string,
    text: string,
  },
|};

export function ProductSpaceIntroductionLine({ config, id, ...props }: Props) {
  addTranslationKeys(config);

  return (
    <SiteContainer id={id} className="Line" size="medium">
      <ProductSpaceIntroduction {...props} />
    </SiteContainer>
  );
}
